module.exports = __webpack_public_path__ + "Banner_Lifehack_repeatable-1e6972985105ee6d29300509a0e6e762.svg";